<div class="deployment-banner" *ngIf="showBanner$ | async">
  <div class="banner-content">
    <mat-icon class="banner-icon">info</mat-icon>
    <div class="banner-text">
      <div class="banner-title">New Version Available</div>
      <div class="banner-message">
        Please clear your browser cache and log out to ensure you're using the latest version.
      </div>
    </div>
    <button mat-icon-button (click)="dismissBanner()" class="close-button" aria-label="Close banner">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
